import React from 'react';
import { Lock } from 'lucide-react';
import { PRIVATE_BOOKING_LABEL } from '../../utils/bookingSource';

const PrivateBookingBadge = ({ className = '', showIcon = true }) => (
  <span
    className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800 ${className}`}
  >
    {showIcon && <Lock className="w-3 h-3 shrink-0" />}
    {PRIVATE_BOOKING_LABEL}
  </span>
);

export default PrivateBookingBadge;
